import React from 'react';
import { FormattedMessage } from 'react-intl';
import { OptionFormTypes } from '../../../../services/filtering/filter-form-render-service/option-form-types';
import { renderFormBasedOnType } from '../../../../services/filtering/filter-form-render-service/';
import OrdersAssignedToActionableFilterPill from '../../../../components/actionable-filter-pill/connected/orders/assigned-to';
import { ASSIGNED_TO } from '../../../../filters/constants';
import { messages } from './messages';

export const AssignedTo = {
  id: ASSIGNED_TO,
  displayName: <FormattedMessage {...messages.assignedTo} />,
  type: OptionFormTypes.TYPE_ORDER_COLLECTION_FILTER,
  filterValue: 'AssignedTo',
  shouldHideActionButtons: true,
  expectsArgumentAsArray: true,
  allowsMultipleSelection: true,

  render: (criteriaInformations, existingFiltersHelpers) => {
    return renderFormBasedOnType(OptionFormTypes.TYPE_CHECKLIST, criteriaInformations, existingFiltersHelpers);
  },

  actionableFilterPill: OrdersAssignedToActionableFilterPill,
};
